import { useRef } from "react";

/**
 * Radix returns focus only to its own Trigger. Our dialogs open from state, so remember what had
 * focus when the dialog took it and give it back on close.
 */
export function useFocusReturn() {
  const opener = useRef<HTMLElement | null>(null);
  return {
    onOpenAutoFocus: () => {
      opener.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    },
    onCloseAutoFocus: (e: Event) => {
      if (opener.current?.isConnected) {
        e.preventDefault();
        opener.current.focus();
      }
    },
  };
}
